import { useCallback } from 'react';
import { getInlineHelpStoreValue } from '../store/inlineHelpStore';
import { downloadTermManualAction$ } from '../store/downloadTermManualStore';

function useDownloadTermManualActions() {

  const { pageId } = getInlineHelpStoreValue();

  const downloadTermManual = useCallback(
    (s3Object: string) => {
      
      if (!pageId)
        return;

      downloadTermManualAction$.next({
        termKey: s3Object
      });
    },
    [pageId],
  );
  

  return {
    downloadTermManual
  };
}

export default useDownloadTermManualActions;